import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { shallow } from 'zustand/shallow'

interface UseHeader {
  headerHeight: number
  promotionalBannerHeight: number
  setPromotionalBannerHeight: (value: number) => void
  helpMenuHeight: number
  setHelpMenuHeight: (value: number) => void
  navbarHeight: number
  setNavbarHeight: (value: number) => void
}

export const useHeader = create<UseHeader>()(
  subscribeWithSelector((set) => {
    return {
      headerHeight: 0,
      promotionalBannerHeight: 0,
      setPromotionalBannerHeight: (value: number) => {
        set({ promotionalBannerHeight: value })
      },
      helpMenuHeight: 0,
      setHelpMenuHeight: (value: number) => {
        set({ helpMenuHeight: value })
      },
      navbarHeight: 0,
      setNavbarHeight: (value: number) => {
        set({ navbarHeight: value })
      },
    }
  }),
)

useHeader.subscribe(
  (state) => {
    return [
      state.promotionalBannerHeight,
      state.helpMenuHeight,
      state.navbarHeight,
    ]
  },
  ([promotionalBannerHeight, helpMenuHeight, navbarHeight]) => {
    useHeader.setState({
      headerHeight: promotionalBannerHeight + helpMenuHeight + navbarHeight,
    })
  },
  { equalityFn: shallow },
)
